import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoadingWidget } from '~/components/widget/base/LoadingWidget';

export const Route = createFileRoute('/')({
  component: () => <LoadingWidget />,
  loader: () => {
    // Redirect to the default lang/companyId route so the app doesn't hang
    // on the root path. TanStack Router needs a concrete route to match;
    // without this redirect, '/' falls into the NotFoundWidget retry loop.
    throw redirect({
      to: '/$lang/$companyId',
      params: {
        lang: 'de',
        companyId: '70927429839',
      } as any,
      replace: true,
    });
  },
});
